import { OrganizationParametersGeneration } from './OrganizationParametersGeneration'

const saveTelecomOrganization = async (organizationData, providerDispatch, url, headers, sendRequest) => {
  providerDispatch({
    type: 'saving',
    payload: { loading: true },
  })

  headers.body = OrganizationParametersGeneration(organizationData)
  await sendRequest(url, headers, (json, status) => {
    providerDispatch({
      type: 'saving',
      payload: { loading: false },
    })
    if (status === 200) {
      providerDispatch({ type: 'saving', payload: { saved: true } })
    }
    if (json.errors) {
      providerDispatch({ type: 'setErrors', payload: json.errors })
    }
  })
}

export default saveTelecomOrganization
